/**
 * Mobil klaviatura: Telegram/iOS WebView'da `focus()` klaviaturani faqat foydalanuvchi bosishi ichida ochadi.
 * Yozish qadamiga o'tadigan bosishda (`next()`) yashirin inputga darhol fokus beriladi — klaviatura ochiladi,
 * keyin yozish qadami fokusni o'z inputiga oladi (klaviatura ochiq qoladi).
 */
let keeper: HTMLInputElement | null = null;

export function primeKeyboard() {
  if (typeof document === 'undefined') return;
  if (!keeper || !keeper.isConnected) {
    keeper = document.createElement('input');
    keeper.type = 'text';
    keeper.setAttribute('aria-hidden', 'true');
    keeper.tabIndex = -1;
    keeper.autocomplete = 'off';
    keeper.setAttribute('autocapitalize', 'off');
    keeper.setAttribute('autocorrect', 'off');
    // 16px — iOS zoom qilmasligi uchun; ekrandan tashqarida emas (iOS bunday inputni fokuslamaydi), shaffof
    keeper.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;opacity:0;font-size:16px;border:0;padding:0;pointer-events:none;';
    document.body.appendChild(keeper);
  }
  keeper.focus({ preventScroll: true });
}
